module.exports = __webpack_public_path__ + "assets/8675f7dc27dffb6f38883516da085538.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/lines/line_5.mp3
 ** module id = 55
 ** module chunks = 0
 **/